import type { TcDerivativePosition } from '@injectivelabs/sdk-ts'

const PENDING_ACTION_TTL_MS = 5_000
const pendingCloseTimers = new Map<string, ReturnType<typeof setTimeout>>()

export function setPendingCloseMarketId(marketId: string) {
  const positionStore = usePositionStore()

  clearTimeout(pendingCloseTimers.get(marketId))
  pendingCloseTimers.delete(marketId)
  positionStore.pendingCloseMarketIds.add(marketId)
}

export function schedulePendingCloseMarketIdExpiry(marketId: string) {
  const positionStore = usePositionStore()

  if (!positionStore.pendingCloseMarketIds.has(marketId)) {
    return
  }

  clearTimeout(pendingCloseTimers.get(marketId))
  pendingCloseTimers.set(
    marketId,
    setTimeout(() => {
      clearPendingCloseMarketId(marketId)
    }, PENDING_ACTION_TTL_MS)
  )
}

export function clearPendingCloseMarketId(marketId: string) {
  const positionStore = usePositionStore()

  clearTimeout(pendingCloseTimers.get(marketId))
  pendingCloseTimers.delete(marketId)
  positionStore.pendingCloseMarketIds.delete(marketId)
}

export function clearPendingCloseMarketIds() {
  const positionStore = usePositionStore()

  pendingCloseTimers.forEach((timerId) => clearTimeout(timerId))
  pendingCloseTimers.clear()
  positionStore.pendingCloseMarketIds.clear()
}

export function reconcilePendingCloseMarketIds({
  marketId,
  positions
}: {
  marketId?: string
  positions: TcDerivativePosition[]
}) {
  const positionStore = usePositionStore()
  const marketIds = marketId
    ? [marketId].filter((pendingMarketId) =>
        positionStore.pendingCloseMarketIds.has(pendingMarketId)
      )
    : Array.from(positionStore.pendingCloseMarketIds)

  if (marketIds.length === 0) {
    return
  }

  const liveMarketIds = new Set(
    positions.map((position) => position.marketId)
  )

  marketIds.forEach((marketId) => {
    if (!liveMarketIds.has(marketId)) {
      clearPendingCloseMarketId(marketId)
    }
  })
}
